import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AcceptTermGuardService } from "../services/guards/term/accept-term-guard.service";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "main",
  },
  {
    path: "login",
    loadChildren: () => import("../pages/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: '',
    canActivate: [AcceptTermGuardService],
    children: [
      {
        path: "main",
        loadChildren: () => import("../pages/main/main.module").then((m) => m.MainModule),
      },
    ],
  },
  {
    path: "reset-password",
    loadChildren: () => import("../pages/reset-password/reset-password.module").then((m) => m.ResetPasswordModule),
  },
  {
    path: "politica-de-privacidade",
    loadChildren: () => import("../pages/policies/policies.module").then((m) => m.PoliciesModule),
  },
  {
    path: "pending-term",
    loadChildren: () => import("../pages/user-accept-term-pending/user-accept-term-pending.module").then((m) => m.UserAcceptTermPendingModule),
  },
  {
    path: "**",
    loadChildren: () => import("../pages/not-found/not-found.module").then((m) => m.NotFoundModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: "enabled" })],
  exports: [RouterModule],
  providers: [AcceptTermGuardService],
})
export class AppRoutingModule {}
